<template lang="html">
<transition name="fade">
    <aside v-show="show" class="map-sidebar pa-2 elevation-3 white">

        <div v-if="context === 'live'" class="live-list">
            <map-filters v-if="filtersLoaded" />
            <div class="loading loading-filters" v-if="!filtersLoaded">
                <span class="mb-1">Loading map filters</span>
                <v-progress-circular
                indeterminate
                color="accent"
                />
            </div>
        </div>

        <div v-if="context === 'licence'" class="licence-details">
            <v-tooltip left>
                <v-btn
                @click="showLiveList"
                icon
                slot="activator"
                class="close-button right">
                    <v-icon>filter_list</v-icon>
                </v-btn>
                <span>View filters</span>
            </v-tooltip>
            <licence-details />
        </div>

        <div v-if="context === 'watershed'" class="watershed-details">
            <v-tooltip left>
                <v-btn
                @click="showLiveList"
                icon
                slot="activator"
                class="close-button right">
                    <v-icon>filter_list</v-icon>
                </v-btn>
                <span>View filters</span>
            </v-tooltip>
            <watershed-details />
        </div>
    </aside>
</transition>
</template>

<script>
import MapFilters from '@/components/WatershedFilters';
import LicenceDetails from '@/components/SidebarLicence';
import WatershedDetails from '@/components/SidebarWatershed';
import * as actions from '@/constants/actions';

export default {
    name: 'map-sidebar',
    components: {
        MapFilters,
        LicenceDetails,
        WatershedDetails,
    },
    data() {
        return {
            showFilters: false,
        };
    },
    computed: {
        show: {
            get() {
                return this.$store.state.sidebar.show;
            },
            set(val) {
                this.$store.dispatch(actions.SHOW_MAP_SIDEBAR, val);
            },
        },
        context() {
            return this.$store.state.sidebar.context;
        },
        classObj() {
            return [
                this.show ? 'showing' : 'hidden',
            ];
        },
        // if filters are loaded into vuex and the filter options query is done
        filtersLoaded() {
            const filters = this.$store.state.loadedFilters.length > 0;
            const options = Object.keys(this.$store.state.filterOptions).length > 0;
            return filters && options;
        },
    },
    methods: {
        /**
         * scroll the sidebar to the top and show the filters component
         */
        revealFilters() {
            // scroll to reveal the filters panel
            const el = document.getElementById('filters-panel');
            el.scrollIntoView();
            this.showFilters = true;
        },
        /**
         * set sidebar context to live results list
         */
        showLiveList() {
            this.$store.dispatch(actions.SET_SIDEBAR_CONTEXT, 'live');
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/assets/globals.scss';

.map-sidebar {
    z-index: 4;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: $sidebar-width;
    overflow-y: scroll;

    .loading {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 1rem;
    }

}

// map sidebar mobile view
@media (max-width: $sidebar-width + 2rem) {
    .map-sidebar {
        max-width: 87vw; // fill most of the width, leaving some nav visible
    }
}

// fade transition
.fade-enter-active, .fade-leave-active {
  transition: opacity .25s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/components/WatershedSidebar.vue